import { phoneExtDepartmentService } from '@/services/api/phoneExtDepartment.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { phoneExtDepartment } from '@/models/api/phoneExtDepartment.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    listByGroup: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PHONE_EXT_DEPARTMENT_MODULE = "api/phoneExtDepartment";

// ACTIONS
export const GET_ALL_PHONE_EXT_DEPARTMENT = 'getAllPhoneExtDepartment';
export const CREATE_PHONE_EXT_DEPARTMENT = 'createPhoneExtDepartment';
export const GET_PHONE_EXT_DEPARTMENT = 'getPhoneExtDepartment';
export const UPDATE_PHONE_EXT_DEPARTMENT = 'updatePhoneExtDepartment';
export const UPDATE_PHONE_EXT_DEPARTMENT_STATUS = 'updatePhoneExtDepartmentStatus';
export const UPDATE_PHONE_EXT_DEPARTMENT_SEQUENCE = 'updatePhoneExtDepartmentSequence';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PHONE_EXT_DEPARTMENT_SUCCESS = "allPhoneExtDepartmentSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PHONE_EXT_DEPARTMENT_SUCCESS = "getPhoneExtDepartmentSuccess";

export const actions = {
    [GET_ALL_PHONE_EXT_DEPARTMENT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return phoneExtDepartmentService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PHONE_EXT_DEPARTMENT_SUCCESS, {data: result, filter});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_DEPARTMENT_SEQUENCE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtDepartmentService
            .updateSequence(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('label.sequence')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [CREATE_PHONE_EXT_DEPARTMENT]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtDepartmentService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PHONE_EXT_DEPARTMENT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return phoneExtDepartmentService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PHONE_EXT_DEPARTMENT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_DEPARTMENT]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtDepartmentService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PHONE_EXT_DEPARTMENT_STATUS]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtDepartmentService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PHONE_EXT_DEPARTMENT_SUCCESS](state, {data, filter}) {
        const groups = data.success ? (data.data || [])
            .map(item => phoneExtDepartment(item))
            .filter(item => item.isActive)
            .sort((a, b) => (a.sequence || 0) - (b.sequence || 0)) : [];
        state.listByGroup = { ...state.listByGroup, [filter.phoneExtGroupUuid]: groups };
    },
    setPhoneExtDepartmentByGroup(state, {phoneExtGroupUuid, data}) {
        state.listByGroup = { ...state.listByGroup, [phoneExtGroupUuid]: data };
    },
    [GET_PHONE_EXT_DEPARTMENT_SUCCESS](state, data) {
        state.details = phoneExtDepartment(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

